<template>
      <div class="tab_action">
    <!--   <slot name="btn"></slot> -->
        <span v-if="isDetail" class="btn show_btn" @click="goDetail"><i class="iconfont">&#xe67c;</i>查看</span>
        <span v-if="isAdd" class="btn add_btn" @click="goAdd"><i class="iconfont">&#xe7e4;</i>新增</span>
        <span v-if="isBatch" class="btn edit_btn" @click="goBatch"><i class="iconfont">&#xe678;</i>维护批次特性</span>
        <span v-if="isEdit" class="btn edit_btn" @click="goEdit"><i class="iconfont">&#xe678;</i>编辑</span>
        <span v-if="isAlter" class="btn edit_btn" @click="goAlter"><i class="iconfont">&#xe678;</i>更改物料</span>
        <span v-if="isSimulatedPrice" class="btn edit_btn" @click="goSimulatedPrice"><i class="iconfont">&#xe678;</i>模拟价格</span>
        <span v-if="isDel" class="btn del_btn" @click="goDel"><i class="iconfont">&#xe618;</i>删除</span>
        <span v-if="isCheck" class="btn check_btn" @click="goCheck"><i class="iconfont">&#xe678;</i>物料核对信息</span>
        <span v-if="isChange" class="btn check_btn" @click="goChange"><i class="iconfont">&#xe678;</i>销售转生产</span>
        <span v-if="isFreeze_s" class="btn freeze_btn" @click="goFreeze"><i class="iconfont">&#xe66f;</i>冻结</span>
        <span v-if="isEmpower" class="btn empower_btn" @click="goEmpower"><i class="iconfont">&#xe605;</i>授权</span>
        <span v-if="isResetEmpower" class="btn ResetEmpower" @click="goResetEmpower"><i class="iconfont">&#xe605;</i>下发授权</span>
        <span v-if="isOpenaccount" class="btn openaccount_btn" @click="goOpenaccount"><i class="iconfont">&#xe627;</i>开户账号</span>
    

        <template v-if="isDelStatus">
          <span v-if="sdata.maintainStatus === 'X' " class="btn restore_btn" @click="restore"><i class="iconfont">&#xe63b;</i>恢复单条删除</span>
          <span v-else class="btn del_btn" @click="goDel"><i class="iconfont">&#xe618;</i>单条删除</span>
        </template>

        <template v-if="isDelStatu">
          <span v-if="sdata.delId === '0011' " class="btn restore_btn" @click="restore"><i class="iconfont">&#xe63b;</i>恢复单条删除</span>
          <span v-else class="btn del_btn" @click="goDel"><i class="iconfont">&#xe618;</i>单条删除</span>
        </template>
        <template v-if="isFreeze && sdata && stata.freezeStatus">
          <span v-if="sdata.freezeStatus ==='F' " class="btn unfreeze_btn" @click="unFreeze"><i class="iconfont">&#xe632;</i>解除解冻</span>
          <span v-else class="btn freeze_btn" @click="freeze"><i class="iconfont">&#xe66f;</i>冻结</span>
        </template>

        <template v-if="isExcel">
          <span class="btn upload_btn" @click="uploadBtn">上传Excel</span>
          <el-dialog title="上传文件" :visible.sync="uploadDialog" class="eldialog" width="410px" v-loading="$store.state.isLoading">
            <el-form ref="addForm" class="eldialogForm" id="addForm">
              <el-form-item label >
                <el-upload
                  class="upload-demo"
                  drag
                  :before-upload="beforeUpload"
                  :on-exceed="handleExceed"
                  :limit="1"
                  :http-request="uploadFile"
                  multiple
                  ref="upload"
                  action
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    将文件拖到此处，或
                    <em>点击上传</em>
                  </div>
                  <div class="el-upload__tip" slot="tip">只能上传Excel文件，且不超过2M</div>
                </el-upload>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="closeFile()">取 消</el-button>
              <el-button type="primary" @click="postFile" :disabled="uploading">确 定</el-button>
            </div>
          </el-dialog>
        <span class="btn upload_btn" @click="download">下载Excel模板</span>
        </template>
        <span v-if="isExcelExport" class="btn upload_btn" @click="exportExcel"> <i class="iconfont">&#xe673;</i> 导出数据</span>
        <!-- 动态按钮  -->
        <slot class="other"></slot>
      </div>
</template>

<script>
import { excelUpload, excelDownload } from "api/excel.js";
export default{
	props:{
		listArr:Array,
		sdata:Object,
    postExcelData:Object,
    isDetail:Boolean,//是否显示查看按钮
    isEmpower:Boolean,//是否显示授权按钮
    isOpenaccount:Boolean,//是否显示开户账号按钮
    isResetEmpower:Boolean,

		isAdd:Boolean,//是否显示添加按钮
    isEdit:Boolean,//是否显示编辑按钮
    isAlter:Boolean,//是否显示更改物料按钮
    isBatch:Boolean,//是否显示维护批次特性按钮
    isCheck:Boolean,//是否显示物料核对信息按钮
    isChange:Boolean,//是否显示销售订单转生产订单按钮
    isSimulatedPrice:Boolean,//是否显示模拟销售价格按钮
    isFreeze_s:Boolean,//是否显示单一的冻结按钮
    isDel:Boolean,//是否显示删除按钮
    isDelStatus:Boolean,//显示删除和恢复按钮
    isDelStatu:Boolean,//生产订单显示删除和恢复按钮
    isFreeze:Boolean,//是否显示冻结和解除冻结
    isExcel:Boolean,//EXCEL按钮
    isExcelExport:Boolean,//导出excel
    uploadUrl:String,//上传url
    exportUrl:String,//导出excel的URL
	  exportWhere:Object,//导出excel的条件
	},
  data(){
    return{
      //上传excel表格
      uploadDialog: false,
      uploading:false,
      downloadUrl:excelDownload.BomMaterialOutStock,
      file: []
    }
  },
	created(){
	},
	methods:{
		//详情
		goDetail(){this.$emit('detail');},
		//添加
		goAdd(){this.$emit('add');},
		//编辑
    goEdit(){this.$emit('edit');},
    //更改物料
    goAlter(){this.$emit('alter');},
    //维护批次特性
    goBatch(){this.$emit('batch');},
    //物料核对信息
    goCheck(){this.$emit('check');},
    //销售订单转生产订单
    goChange(){this.$emit('change');},
    //模拟价格
		goSimulatedPrice(){this.$emit('simulatedPrice');},
		//删除
		goDel(){this.$emit('del');},
		//恢复删除
		restore(){this.$emit('restore');},
    //冻结
    freeze(){this.$emit('freeze');},
    //授权
    goEmpower(){this.$emit('empower');},
    //重置授权
    goResetEmpower(){this.$emit('goResetEmpower');},
    
    //开户账号
		goOpenaccount(){this.$emit('openaccount');},
    //解冻
    unFreeze(){this.$emit('unFreeze');},
    //单一冻结
    goFreeze(){this.$emit('freeze_s');},
    //关闭
    closeFile() {
      this.$refs.upload.clearFiles();
      this.uploadDialog = false;
    },
    //导出excel 
    exportExcel(){
      console.log(this.exportWhere,'导出条件')
      this.$exportExcel(this.exportUrl,this.exportWhere);
    },
    //点击上传按钮之前
    uploadBtn(){
      this.$emit('uploadBtn');
      //this.uploadDialog = true;
    },
    download() {
      this.$download(this.downloadUrl);
      /* this.$message.info("开始下载模板");
      //let url = "http://192.168.2.249:8080/purchasemng/purchaseinstock/excel/tpl";   //填写后端的路径
      let iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = this.downloadUrl;
      iframe.onload = function() {
        document.body.removeChild(iframe);
      };
      iframe.onerror = function(){

      };
      document.body.appendChild(iframe);   //第一种方式效果较好
      // window.open( “后端给的路径”);        //   第二种方式,采用打开新窗口，会出现屏幕快闪一下，效果不好 */
    },

    //上传excel表格
    beforeUpload(file) {
      const fileName = file.name.split('.');
      let fileType = fileName[fileName.length-1].toLowerCase();
      let excelArr = ["xls","xlsx"];
      let isIn = excelArr.indexOf(fileType);
      //console.log(fileType,isIn,2222);
      if(isIn == -1){
        this.$refs.upload.clearFiles();
        this.$message.error('上传文件必须是Excel格式!');
        return false;
      }
      let fileSize = file.size;
      if(fileSize > 2097152){
        this.$message.error("上传文件大小不能超过2M");
        return false;
      }
      return true;
      const isText = file.type === "application/vnd.ms-excel";
      const isTextComputer =
    	file.type ===
    	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (!isText && !isTextComputer) {
        this.$message.error("上传文件必须是Excel格式!");
      }
      return isText || isTextComputer;
    },
    // 上传文件个数超过定义的数量
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，请删除后继续上传`);
    },
    uploadFile(item) {
      this.file = item.file;
    },
    async postFile() {
      const fileObj = this.file;
      if(!fileObj.size){
        this.$message.warning("请选择需要上传的excel文件");
        return false;
      }
      this.uploading = true;
      this.$store.state.isLoading = true;
      var fileData = new FormData();
      fileData.append("file", fileObj);

      if(this.postExcelData){
        for(var item in this.postExcelData){
          fileData.append(item,this.postExcelData[item]);
        }
      }
      /* "factoryCode":this.fromData.factoryCode,//工厂
      "factoryDesc":this.fromData.factoryDesc,
      "factoryId":this.fromData.factoryId,
      "inventoryCode":this.fromData.inventoryCode,//库存地
      "inventoryDesc":this.fromData.inventoryDes,
      "inventoryId":this.fromData.inventoryId, */

      let res = await this.$upload(this.uploadUrl,fileData);
      console.log(res,'上传返回的数据');
      this.uploading = false;
      this.$store.state.isLoading = false;
      if(!res.status){
        this.$message.error(res.msg);
      }else{
        this.uploadDialog = false;
        this.$refs.upload.clearFiles();
        this.$emit('uploadExcel',res);
      }
      return;
    }


	}
}
</script>

<style>
</style>
